import React, { Component } from 'react';
import "./style/PanelInfo.css";

const PanelInfo = function (props) {

    let style = {}

    const flexDirection = props.flexDirection;

    if (flexDirection) {
        style["flexDirection"] = flexDirection
    }

    return (
        <aside role={props.role} className="panelInfo" style={style}>
            {props.children}
        </aside>
    )
}

export default PanelInfo;